import React, {useState, useEffect} from 'react';
import {Result, Skeleton} from 'antd';
import {useRouteMatch} from "react-router-dom";
import {callApi} from '../Utills/ApiRest';

const PermanentMeetingLinkRecaptcha = (props) => {
    let match = useRouteMatch();
    const [exists, setExists] = useState(undefined);

    useEffect(() => {
        const getDirectMeetingToken = (meetingLink) => {
            return callApi(`/external/direct-meeting/${meetingLink}`, {}, {method: 'get'});
        }

        try {
            getDirectMeetingToken(match.params.meetingLink).then(response => {
                window.location.href = `/set-meeting/${response.token}?mode=permanentSuggestion`;
            })
        } catch (error) {
            console.error(error)
            setExists(false)
        }
    }, [match.params.meetingLink])


    if (exists === undefined) {
        return <Skeleton className="p-2"/>
    } else if (exists === false) {
        return <Result status='404' title='404' subTitle='Sorry, the page you are looking for does not exist'/>
    }
}

export default PermanentMeetingLinkRecaptcha;